import { useIntl } from '@/intl'
import { useState } from 'react'

export const useTexts = () => {
  const { translate } = useIntl()

  const [api] = useState(() => ({
    subject: translate({
      id: 'sms4.settings.communication.notifications.form.subjectCustom.label',
    }),
    text: translate({
      id: 'sms4.settings.communication.notifications.form.message.email.label',
    }),
    emailBackupSubject: translate({
      id: 'sms4.settings.communication.notifications.form.backupSubject.label',
    }),
    helperText: (notificationType: string) =>
      translate({
        id: 'sms4.settings.communication.notifications.notificationPreview.helperText',
        values: { notificationType },
      }),
  }))

  return api
}
